<!--@formatter:off-->
<i18n src="./locale.json"></i18n>
<!--@formatter:on-->

<style lang="sass" scoped>
@import 'component'
</style>

<template lang="pug">

  form(v-on:submit.prevent="onSubmit")

    c-form-info(v-bind:message="$t(message)") 
    c-form-error(v-bind:message="$t(responseErrorMessage)")

    div.form-group
      input(autofocus type="number" name="code" v-bind:placeholder="$t('placeholder_code')" v-model="model.code")

    div(v-if="timerCounts > 0 && phoneCode && phoneNumber")
      div(v-if="seconds > 0")
        span(v-bind:class="(seconds !== 0) ? 'disabled' : ''") {{ $tc('label_resending_code', seconds, { seconds: seconds }) }}
      div(v-else)
        div.link-resend-code(v-on:click.stop="resendCode") {{ $t('link_resend_code') }}

    c-form-submit(v-bind:isDisabled="isInvalidRequestParams()" v-bind:isLoading="requestBeingProcessed") {{ $t('btn_check_security_code') }}

</template>

<script>
import { minLength, required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';

import * as errorCodes from 'classes/error-codes';
import * as responseCodes from 'classes/response-codes';
import cFormError from 'components/c-form/c-form-error/component';
import cFormInfo from 'components/c-form/c-form-info/component';
import cFormSubmit from 'components/c-form/c-form-submit/component';
import mFormSubmit from 'mixins/formSubmit';
import mMask from 'mixins/mask';
import * as types from 'store/mutation-types';

export default {
  mixins: [mMask, mFormSubmit],

  components: {
    cFormError,
    cFormInfo,
    cFormSubmit,
  },

  data() {
    return {
      code: '',
      seconds: 0,
      timerId: null,
      timerCounts: 5,
      message: null,
      model: {
        code: null,
      },
    };
  },

  validations: {
    model: {
      code: {
        required,
        minLength: minLength(4),
      },
    },
  },

  computed: {
    ...mapGetters('registration', ['phoneCode', 'phoneNumber', 'phoneNumberE164']),
  },

  mounted() {
    this.$store.commit(`registration/${types.SET_SMS_CODE}`, null);
    this.$store.commit(`registration/${types.SET_SMS_CODE_VALID}`, false);

    if (!this.phoneCode || !this.phoneNumber) {
      this.$router.push({ name: 'enter-number' });
    }
  },

  methods: {
    onSubmit() {
      if (this.isInvalidRequestParams() && this.model.code) {
        this.setResponseError('Некорректный код');
        return;
      }
      if (this.isInvalidRequestParams() && !this.model.code) {
        this.setResponseError('Укажите код');
        return;
      }
      this.handleSubmit();
    },
    onBeforeRequest() {
      this.mask();
    },

    onAfterRequest() {
      this.unmask();
    },

    handleRequestUrl() {
      return '/security-code/check-code';
    },

    handleRequestParams() {
      return {
        recipient: this.phoneNumberE164,
        security_code: this.model.code,
      };
    },

    /**
     * Обработка ответа формы
     */
    handleResponse(response) {
      switch (this.getResponceStatusCode(response)) {
        case responseCodes.RESPONSE_SECURITY_CODE_IS_VALID:
          // Сохраняем данные о коде
          this.$store.commit(`registration/${types.SET_SMS_CODE}`, this.model.code);
          this.$store.commit(`registration/${types.SET_SMS_CODE_VALID}`, true);

          // Проверяем тип токена
          switch (this.getResponceKey(response, 'data.token_scope')) {
            // Это восстановлениек пароля
            case 'forgot-password':
              this.$router.push({ name: 'forgot-password' });
              break;

            // Это ввод номера телефона
            case 'enter-phone-number':
              // Проверяем номер телефона на валидность
              this.$http
                .post('/phone-number/check-phone-number', {
                  phone_code: this.phoneCode,
                  phone_number: this.phoneNumber,
                })
                .then((response) => {
                  // Успех
                  switch (this.getResponceStatusCode(response)) {
                    // Номер телефона подтвержден, нужно ввести пароль
                    case responseCodes.RESPONSE_PHONE_NUMBER_CONFIRMED:
                      this.$router.push({ name: 'enter-password' });
                      break;
                  }

                  // Проверяем ошибки
                  switch (this.getResponceErrorCode(response)) {
                    // Профиль пользователя не подтвержден, нужно обновить данные
                    case errorCodes.ERROR_USER_PROFILE_IS_NOT_CONFIRMED:
                      this.$router.push({ name: 'confirmation' });
                      break;

                    // Номер телефона не существует, нужна регистрация
                    case errorCodes.ERROR_PHONE_NUMBER_DOES_NOT_EXIST:
                      this.$router.push({ name: 'registration' });
                      break;

                    // Показываем ошибку
                    default:
                      this.handleResponseError(response);
                  }
                })
                .catch((error) => {
                  this.catchResponseError(error);
                });
              break;
          }
          break;
      }
    },

    /**
     * Повторная отправка кода
     */
    resendCode() {
      this.timerCounts--;
      if (this.timerCounts > 0) {
        this.timer(60);

        // Проверяем номер телефона
        this.$http
          .post('/phone-number/send-security-code', {
            token_scope: 'enter-phone-number',
            phone_code: this.phoneCode,
            phone_number: this.phoneNumber,
          })
          .then((response) => {
            if (this.isSuccessfulRequest(response)) {
              switch (this.getResponceStatusCode(response)) {
                case responseCodes.RESPONSE_SECURITY_CODE_WAS_SENT:
                  break;

                default:
                  this.setResponseError('Ошибка генерации токена');
              }
            }
          })

          .catch((error) => {
            this.catchResponseError(error);
          });
      }
    },

    /**
     * Запуск таймера
     * @param seconds
     */
    timer(seconds = null) {
      if (seconds) {
        this.seconds = seconds;
      }

      this.timerId = window.setInterval(() => {
        if (this.seconds > 0) {
          this.seconds--;
        } else {
          window.clearInterval(this.timerId);
        }
      }, 1000);
    },
  },
};
</script>
